import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

import { getFavoritesUrl } from 'helpers/namedUrls';
import Link from 'components/Link';
import FavoriteIcon from 'components/FavoriteIcon';
import ChevronRightIcon from 'components/icons/ChevronRightIcon.com.svg';
import { withTracker, hitTypes } from 'helpers/tracking';
import cn from './styles.local.less';

class FavoritesCounter extends PureComponent {
  static propTypes = {
    totalCount: PropTypes.number.isRequired,
    tracker: PropTypes.object.isRequired,
  };

  handleClick = () => {
    const { tracker } = this.props;

    tracker.track(hitTypes.FAVORITES_OVERVIEW_LINK_CLICK);
  };

  render() {
    const { totalCount } = this.props;

    return (
      <div>
        <Link
          className={cns(cn.favoritesLink, {
            [cn.filledContainer]: totalCount > 0,
          })}
          data-qa-selector="favorites-link"
          rel="nofollow"
          onClick={this.handleClick}
          to={getFavoritesUrl()}
        >
          <div className={cn.heading}>
            <FavoriteIcon
              className={cn.favoriteIcon}
              isFilled={totalCount > 0}
            />{' '}
            <span>
              {__('sidebar.myFavoritesList')} ({totalCount}){' '}
            </span>
          </div>

          <ChevronRightIcon className={cn.arrowIcon} />
        </Link>
      </div>
    );
  }
}

export default withTracker(FavoritesCounter);
